export default {"src":"/_next/static/image/public/images/ic_video_end.e19fdb83328d614791b80f609ed26f65.svg","height":56,"width":56};